import React, { useState, useEffect, useRef } from 'react';
// components
import ModalConfirm from './ModalConfirm';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
// ui
import Icon from '@material-ui/core/Icon';

const SimpleText = ({ outputsEl, index, callbackFromParent }) => {
    // state
    const [value, setValue] = useState('');
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [addAtion, setAddAtion] = useState('');

    // 텍스트 바뀔 때마다 넣음
    useEffect(() => {
        setValue(
            outputsEl.simpleText.text
                ? outputsEl.simpleText.text.substring(0, 1000)
                : ''
        );
    }, [outputsEl]);

    // maxLength keyup event
    const checkMaxLength = (e) => {
        const valueLength = e.target.value.length;
        const maxlength = e.target.getAttribute('maxlength');
        if (valueLength > maxlength) {
            setValue(e.target.value.substr(0, maxlength));
        }
    };

    // input change
    const onChangeValue = (e) => {
        // json > obj
        let textObj = {
            simpleText: {
                text: e.target.value.substring(0, 1000),
            },
            index: index,
        };
        callbackFromParent(textObj);
        setValue(e.target.value);
    };

    //  심플 > 텍스트카드  아ㅏㅏㅏㅏ 함수 좀 나눠야겠다..
    const callBackConfirmAction = (action, type) => {
        let changedValue = value;
        if (action === 'submit') {
            if (type === 'addBtn') {
                changedValue = value.substring(0, 400);
                //change carousel
                let textCardObj = {
                    carousel: {
                        type: 'textCard',
                        random: false,
                        items: [
                            {
                                description: changedValue,
                                buttons: [
                                    {
                                        label: '버튼 설정',
                                        action: 'webLink',
                                        webLinkUrl: '',
                                    },
                                ],
                            },
                        ],
                    },
                    index: index,
                };
                callbackFromParent(textCardObj);
            } else if (type === 'addItem') {
                changedValue = value.substring(0, 128);
                //change carousel
                let textCardObj = {
                    carousel: {
                        type: 'textCard',
                        random: false,
                        items: [
                            {
                                description: changedValue,
                            },
                            {
                                description: '',
                            },
                        ],
                    },
                    index: index,
                };
                callbackFromParent(textCardObj);
            } else {
                setIsOpenModal(false);
            }
        } else {
            setIsOpenModal(false);
        }
    };

    // 버튼 추가, 아이템 추가 눌렀을때 글자 수 확인 모달
    const onClickAdd = (e) => {
        setAddAtion(e.target.name);
        setIsOpenModal(true);
    };

    // 모달
    const modalNode = useRef();
    // 모달 닫기
    const closeSet = (e) => {
        if (modalNode.current.contains(e.target)) {
            // inside click
            return;
        }
        setIsOpenModal(false);
    };
    // 모달 닫기
    useEffect(() => {
        // add when mounted
        document.addEventListener('mousedown', closeSet);
        // return function to be called when unmounted
        return () => {
            document.removeEventListener('mousedown', closeSet);
        };
    }, []);

    return (
        <>
            <div className="item-cont">
                <div className="item txt">
                    <div className="item-inp-cont">
                        <TextareaAutosize
                            rowsMin={2}
                            rowsMax={15}
                            spellCheck="false"
                            placeholder="텍스트를 입력해주세요."
                            value={value}
                            onChange={onChangeValue}
                            onKeyUp={checkMaxLength}
                            maxLength="1000"
                            className="empty"
                        />
                        <span>
                            <span>{value.length}</span>/1000
                        </span>
                        ${!value.length && <i>*</i>}
                    </div>
                    <button
                        className="btn-list-add-btn only"
                        onClick={onClickAdd}
                        name="addBtn"
                    >
                        + 버튼 추가
                    </button>
                </div>
            </div>
            <div className="item-cont">
                <div className="item add">
                    <button type="button" onClick={onClickAdd} name="addItem">
                        <Icon>add_circle_outline</Icon>
                    </button>
                </div>
            </div>
            <div ref={modalNode}>
                {isOpenModal && (
                    <ModalConfirm
                        callBackConfirmAction={callBackConfirmAction}
                        addAtion={addAtion}
                    />
                )}
            </div>
        </>
    );
};

SimpleText.defaultProps = {
    // bla: 'test',
};

export default SimpleText;
